<article>
	<app-schematics-card [schematic]="schematic"></app-schematics-card>
</article>
